import { css, CSSObject, keyframes } from '@emotion/react';
import ArticleIcon from '@mui/icons-material/Article';
import AssessmentIcon from '@mui/icons-material/Assessment';
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
import InsertDriveFileIcon from '@mui/icons-material/InsertDriveFile';
import { CustomTemplateSectionType } from '../../../../../schemas/kpi-template.schema';
import { colors } from '../../../../../theme/colors';

export const sectionCardCss: CSSObject = {
  border: `1px solid ${colors.neutral[20]}`,
  borderRadius: '4px',
  background: colors.primary[0],
  overflow: 'hidden',
};

export const kpiRowAddIn = keyframes({
  from: { opacity: 0, transform: 'translateY(-4px)' },
  to: { opacity: 1, transform: 'translateY(0)' },
});

export const kpiItemBaseCss: CSSObject = {
  display: 'grid',
  columnGap: '0.5rem',
  alignItems: 'center',
  borderBottom: `1px solid ${colors.neutral[10]}`,
  transition: 'background-color 150ms ease',
  '&:hover': {
    backgroundColor: 'var(--mui-palette-action-hover)',
  },
};

export const kpiListCss = css({
  '& > ul': {
    rowGap: 0,
  },
});

export const sectionIconSx = { ml: '-0.5rem' } as const;

export const toggleGroupSx = {
  '& .MuiToggleButton-root': {
    py: 0.5,
    px: 2,
    fontSize: '0.875rem',
    textTransform: 'none',
  },
} as const;

export const SectionTypeIcon = {
  [CustomTemplateSectionType.quantitative]: AssessmentIcon,
  [CustomTemplateSectionType.textual]: ArticleIcon,
  [CustomTemplateSectionType.file]: InsertDriveFileIcon,
  [CustomTemplateSectionType.date]: CalendarTodayIcon,
} as const;
